export default __webpack_public_path__ + "static/media/paytm1.72338a31.svg";